<style>
    .sbcx-container {
        padding: 30px;
    }
</style>
<template>
    <el-card>    
        <div class="sbcx-container">
            <el-tabs v-model="activeName" >
                <template v-for="el in buttonConfig">
                    <!--三包理赔明细查询 start-->
                    <el-tab-pane label="三包理赔明细查询" name="sblpmx" v-if="el.type == 'sblpmx'">                
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="sblpmxDateRange"></ly-date-picker>
                            </el-form-item>                                       
                            <el-form-item label="指定批次">   
                                <ly-batch width="220px" v-model="sblpmx.pici"></ly-batch>
                            </el-form-item>
                            <el-form-item label="理赔方式">    
                                <ly-checkbox 
                                    :data-list="lptypes" 
                                    :is-all="true" 
                                    default-check="all" 
                                    v-model="sblpmx.lp_type">
                                </ly-checkbox>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/jingyingtd" v-model="sblpmx.jytd"></ly-select>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isSblpmxShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                <ly-product-table v-if="!isSblpmxShowCustomer" :thead-config="customerConfig" ref="sblpmxCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!--三包理赔明细查询 end-->
                    <!--三包理赔汇总查询 start-->
                    <el-tab-pane label="三包理赔汇总查询" name="sblphz" v-else-if="el.type == 'sblphz'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="sblphzDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="指定方式">
                                <el-radio-group v-model="sblphz.type">
                                    <el-radio label="brand">按品牌</el-radio>
                                    <el-radio label="pici">按批次</el-radio>
                                    <el-radio label="lpfs">按理赔方式</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/jingyingtd" v-model="sblphz.jytd"></ly-select>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!--三包理赔汇总查询 end-->
                    <!--三包理赔综合查询 start-->
                    <el-tab-pane label="三包理赔综合查询" name="sblpzh" v-else-if="el.type == 'sblpzh'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="sblpzhDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="指定品牌">
                                <ly-checkbox :data-list="productbrands" :is-all="true" default-check="all" v-model="sblpzh.product_brand" style="width:700px"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定尺寸">
                                <ly-checkbox :data-list="sizes" :is-all="true" :type="2" default-check="all" @input="onCheckedChange" style="width:700px"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/jingyingtd" v-model="sblpzh.jytd"></ly-select>
                            </el-form-item>
                            <el-form-item label="指定个别货品" style="width:702px">
                                <el-checkbox label="全部" name="type" v-model="isSblpzhShowProduct"></el-checkbox>
                                <ly-product-table 
                                    ref="sblpzhCustomer" 
                                    :thead-config="productConfig" 
                                    v-if="!isSblpzhShowProduct"></ly-product-table>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!--三包理赔综合查询 end-->
                    <!-- 三包登记明细查询  2017-12-27 zjs 添加 start -->
                    <el-tab-pane label="三包登记明细查询" name="sbdjmx" v-else-if="el.type == 'sbdjmx'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="sbdjmxDateRange"></ly-date-picker>
                            </el-form-item>                                   
                            <el-form-item label="指定批次">   
                                <ly-batch width="220px" v-model="sbdjmx.pici"></ly-batch>
                            </el-form-item>
                            <el-form-item label="引用状态">    
                                <ly-checkbox 
                                    :data-list="yytypes" 
                                    :is-all="true" 
                                    default-check="all" 
                                    v-model="sbdjmx.yy_type">
                                </ly-checkbox>
                            </el-form-item>
                            <el-form-item label="经营团队">
                                <ly-select width="220px" api="api/jingyingtd" v-model="sbdjmx.jytd"></ly-select>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isSbdjmxShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                <ly-product-table v-if="!isSbdjmxShowCustomer" :thead-config="customerConfig" ref="sbdjmxCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 三包登记明细查询  2017-12-27 zjs 添加  end  -->
                    <el-tab-pane label="三包理赔费用查询" name="sblpfy" v-else-if="el.type == 'sblpfy'">
                        <ly-sblpfy
                            :customer-config="customerConfig"
                            ref="sblpfy">
                        </ly-sblpfy>
                    </el-tab-pane>
                </template>
            </el-tabs>
            <!--底部提交按钮-->
            <el-form :label-width="labelWidth" v-if="buttonConfig && buttonConfig.length > 0">
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交查询</el-button>
                </el-form-item>
            </el-form>
            <!--底部提交按钮-->            
        </div>  
    </el-card> 
</template>
<script>
    /**
     * 三包查询
     * @author wxf
     * @time 2017-9-14
     */
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyBatch from '@c/batch'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import Search from './Search'
    import LyCheckbox from '@c/checkbox'
    
    import LySblpfy from './sblpfy'

    export default {
        mixins: [Search],
        components: {
            LyDatePicker,
            LySearchForm,
            LySelect, 
            LyBatch,
            LyProductTable,
            LyCheckbox,
            LySblpfy
        },
        data () {
            return {
                activeName: 'sblpmx',
                labelWidth: '100px', // 标题宽度，统一设置为了以后方便调整             
                sblpmxDateRange: "", // 三包理赔明细查询时间段
                sblphzDateRange: "", // 三包理赔汇总查询时间段
                sblpzhDateRange: "", // 三包理赔综合查询时间段
                sbdjmxDateRange: "", // 三包登记明细查询时间段
                sblpmx: { // 三包理赔明细上传数据
                    ticket: "sblpmx",
                    date_start: "",
                    date_end: "",
                    lp_type: ['0'],	
                    jytd: "",	
                    customer: [],
                    pici: ""                   
                },
                sblphz: { // 三包理赔汇总上传数据
                    ticket: "sblphz",
                    date_start: "",
                    date_end: "",
                    jytd: "",	
                    type: "brand"       
                },
                sblpzh: { // 三包理赔综合上传数据
                    ticket: "sblpzh",
                    date_start: "",
                    date_end: "",
                    jytd: "",	
                    product_brand: [],       
                    size: [],       
                    product: []       
                },
                sbdjmx: { // 三包登记明细查询
                    ticket: 'sbdjmx',
                    date_start: "",
                    date_end: "",
                    yy_type: [''],
                    pici: "",
                    jytd: "",   
                    customer: []
                },
                formdata: {}, // 上传数据
                productbrands: [], // 货品品牌列表
                isSblpmxShowCustomer: true, // 控制三包理赔明细指定个别客户的全选与否
                isSblpzhShowProduct: true, // 控制三包理赔综合指定个别货品的全选与否  
                isSbdjmxShowCustomer: true, // 控制三包登记明细查询指定个别客户的全选与否  
                lptypes: [{id: 1, name:'赔胎'},{id: 2,name: '赔钱'}], // 货品品牌列表
                yytypes: [{id: 1, name:'未被引用'},{id: 2,name: '引用完成'}], // 引用状态
                sizes: [{id: 13, name:'13寸'},{id: 14, name:'14寸'},{id: 15, name:'15寸'},
                    {id: 16, name:'16寸'},{id: 17, name:'17寸'},{id: 18, name:'18寸'},
                    {id: 19, name:'19寸'},{id: 20, name:'20寸'},{id: 21, name:'21寸'}], // 尺寸列表
                radiochecked: '',
                buttonConfig: {} // tab按钮的配置
            }
        },
        watch: {
            'sblpmxDateRange' (v) { // 三包理赔明细查询时间段拆分赋值
                this.sblpmx.date_start = v.split("~")[0];
                this.sblpmx.date_end = v.split("~")[1];
            },
            'sblphzDateRange' (v) { // 三包理赔汇总查询时间段拆分赋值
                this.sblphz.date_start = v.split("~")[0];
                this.sblphz.date_end = v.split("~")[1];
            },
            'sblpzhDateRange' (v) { // 三包理赔综合查询时间段拆分赋值
                this.sblpzh.date_start = v.split("~")[0];
                this.sblpzh.date_end = v.split("~")[1];
            },
            'sbdjmxDateRange' (v) { // 三包登记明细查询时间段拆分赋值
                this.sbdjmx.date_start = v.split("~")[0];
                this.sbdjmx.date_end = v.split("~")[1]
            }
        },
        created () {
            this.readRouteConfig()
        },
        mounted () {
            // 初始化指定时间段，默认为当天
            let today = this.$utils.dateFormat('yyyy-MM-dd',new Date())
            this.sblpmxDateRange = today + "~" + today
            this.sblphzDateRange = today + "~" + today
            this.sblpzhDateRange = today + "~" + today
            // 2018-01-16时间加入默认值
            this.sbdjmxDateRange = today + "~" + today
            this.queryBrand(); // 获取货品品牌列表
        },
        methods: {
            /**
            * 获取或品牌列表
            */
            queryBrand () {
                this.$api.productbrand.query().then((rs) => { // 正确请求成功时处理  
                    this.productbrands = rs;
                    // 把获取的货品品牌的id单独出来成数组
                    rs.map((item) => {
                        this.sblpzh.product_brand.push(item.id);
                    });
                })
            },
            /**
             * 提交查询
             */
            onSubmit () {   
                // 根据不同的tab，设置上传数据
                switch (this.activeName) {
                    case "sblpmx": 
                        let customerIds = []; 
                        if (Object.is(this.isSblpmxShowCustomer,false)) {  
                            // 获取已选数据的id集合
                            customerIds = this.$refs['sblpmxCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIds = Array.from(new Set(customerIds)); 
                        } 
                        this.sblpmx.customer = customerIds // 获取客户列表
                        this.formdata = this.sblpmx;
                        break;
                    case "sblphz": 
                        this.formdata = this.sblphz;
                        break;
                    case "sblpzh": 
                        let productIds = []
                        if (Object.is(this.isSblpzhShowProduct,false)) {  
                            // 获取已选数据的id集合
                            productIds = this.$refs['sblpzhCustomer'][0].getProductData().map((item) => {
                                return item.product.product_id   
                            });
                            // 数组去重
                            productIds = Array.from(new Set(productIds)); 
                        }
                        this.sblpzh.product = productIds // 获取客户列表
                        this.formdata = this.sblpzh;
                        break;   
                    case "sbdjmx":      
                        let djcustomerIds = []
                        if (Object.is(this.isSbdjmxShowCustomer,false)) {  
                            // 获取已选数据的id集合
                            djcustomerIds = this.$refs['sbdjmxCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            djcustomerIds = Array.from(new Set(djcustomerIds)); 
                        } 
                        this.sbdjmx.customer = djcustomerIds // 获取客户列表
                        this.formdata = this.sbdjmx;
                        break;   
                    case 'sblpfy':
                         this.formdata = this.$refs['sblpfy'][0].getFormData()
                        break;             
                }              
                // 调用接口
                this.$api.export.create(this.formdata).then((rs) => { // 正确请求成功时处理  
                    this.$alert('查询任务已提交，请前往查询下载中心下载计算完毕的数据', '提示信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showCancelButton: true,
                        type: 'success'
                    }).then(() => {
                        this.$router.push({name: 'download'})
                    }, () => {})
                }).catch((error) => { // 捕捉错误处理  
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 接受input事件
             */
            onCheckedChange (val) {
                if (val.length === this.sizes.length) {
                    this.sblpzh.size = ['all']
                } else {
                    this.sblpzh.size = val
                }
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                // 获得tab的配置
                if (routeConfig && routeConfig.page && routeConfig.page.length > 0) {
                    let config = routeConfig.page[0]['config']
                    if (typeof config.buttons === 'string') {
                        config.buttons = JSON.parse(config.buttons)
                    }
                    this.buttonConfig = config.buttons || []
                    // 设置默认的activeName 
                    if (this.buttonConfig.length > 0) {
                        this.activeName = this.buttonConfig[0]['type']
                    }
                }
            }
        }
    };
</script>